import React from "react";

const mapsUrl = (address) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

// The displayed phone carries brackets and spaces; tel: only tolerates digits and a leading +.
const telUrl = (phone) => `tel:${phone.replace(/[^\d+]/g, "")}`;

export const Contact = (props) => {
  const data = props.data;

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="section-title text-center">
            <h2>Get In Touch</h2>
            <p>We'd love to hear from you. Reach out through any of the channels below.</p>
          </div>
          <div className="contact-info-grid">
            <a
              className="contact-info-item"
              href={data ? mapsUrl(data.address) : undefined}
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa fa-map-marker"></i>
              <div>
                <h4>Ho Chi Minh City</h4>
                <p>{data ? data.address : "loading"}</p>
                <span className="contact-info-action">Open in Google Maps</span>
              </div>
            </a>
            {data?.address2 && (
              <a
                className="contact-info-item"
                href={mapsUrl(data.address2)}
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa fa-map-marker"></i>
                <div>
                  <h4>Buon Ma Thuot</h4>
                  <p>{data.address2}</p>
                  <span className="contact-info-action">Open in Google Maps</span>
                </div>
              </a>
            )}
            <a
              className="contact-info-item"
              href={data ? telUrl(data.phone) : undefined}
            >
              <i className="fa fa-phone"></i>
              <div>
                <h4>Phone</h4>
                <p>{data ? data.phone : "loading"}</p>
                <span className="contact-info-action">Call now</span>
              </div>
            </a>
            <a
              className="contact-info-item"
              href={data ? `mailto:${data.email}` : undefined}
            >
              <i className="fa fa-envelope-o"></i>
              <div>
                <h4>Email</h4>
                <p>{data ? data.email : "loading"}</p>
                <span className="contact-info-action">Send an email</span>
              </div>
            </a>
          </div>
          <div className="col-md-12">
            <div className="social">
              <ul>
                {props.data?.facebook && (
                  <li>
                    <a href={props.data.facebook} rel="noreferrer" target="_blank">
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                )}
                {props.data?.linkedin && (
                  <li>
                    <a href={props.data.linkedin} rel="noreferrer" target="_blank">
                      <i className="fa fa-linkedin"></i>
                    </a>
                  </li>
                )}
                {props.data?.twitter && (
                  <li>
                    <a href={props.data.twitter} rel="noreferrer" target="_blank">
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                )}
                {props.data?.youtube && (
                  <li>
                    <a href={props.data.youtube} rel="noreferrer" target="_blank">
                      <i className="fa fa-youtube"></i>
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          {/* Hardcoded on purpose: a computed year would differ between the
              prerendered markup and the client after a New Year rollover. */}
          <p>&copy; 2016–2026 Pandobit. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
};
